var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPublishedMap(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Screenshot_2023-01-08_at_11.37.39_PM",
    x: 0,
    y: 0,
    width: 68,
    height: 68,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Screenshot_2023-01-08_at_11.37.39_PM-2",
    x: 0,
    y: 0,
    width: 68,
    height: 68,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Poligon_Icon_-_Published",
    "data-name": "Poligon Icon - Published",
    transform: "translate(9 6)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -9, -6)",
    filter: "url(#Screenshot_2023-01-08_at_11.37.39_PM)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Screenshot_2023-01-08_at_11.37.39_PM-3",
    "data-name": "Screenshot 2023-01-08 at 11.37.39 PM",
    transform: "translate(9 6)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    rx: 12,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 49,
    height: 49,
    rx: 11.5,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Poligon",
    transform: "translate(-47.157 -3018.146)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_7151",
    "data-name": "Path 7151",
    transform: "translate(78.596 3044.259) rotate(-135)",
    fill: "#214a80"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 16.94650459289551 8.580343246459961 L 1.20623767375946 8.569132804870605 L 9.068377494812012 0.7070015072822571 L 16.94650459289551 8.580343246459961 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 9.06849479675293 1.414003849029541 L 2.41249942779541 8.069992065429688 L 15.73802471160889 8.079482078552246 L 9.06849479675293 1.414003849029541 M 9.068275451660156 3.814697265625e-06 L 18.15499496459961 9.081204414367676 L -3.814697265625e-06 9.06827449798584 L 9.068275451660156 3.814697265625e-06 Z",
    stroke: "none",
    fill: "#214a80"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_7155",
    "data-name": "Path 7155",
    transform: "translate(65.802 3057.052) rotate(-135)",
    fill: "#559ae2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 16.94650459289551 8.580343246459961 L 1.20623767375946 8.569132804870605 L 9.068377494812012 0.7070015072822571 L 16.94650459289551 8.580343246459961 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 9.06849479675293 1.414003849029541 L 2.41249942779541 8.069992065429688 L 15.73802471160889 8.079482078552246 L 9.06849479675293 1.414003849029541 M 9.068275451660156 3.814697265625e-06 L 18.15499496459961 9.081204414367676 L -3.814697265625e-06 9.06827449798584 L 9.068275451660156 3.814697265625e-06 Z",
    stroke: "none",
    fill: "#559ae2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_7154",
    "data-name": "Path 7154",
    transform: "translate(85.017 3037.853) rotate(135)",
    fill: "#3566a2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 9.068394660949707 8.37421703338623 L 1.206243753433228 0.5120575428009033 L 16.9465160369873 0.5008646845817566 L 9.068394660949707 8.37421703338623 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 9.068511962890625 7.667213439941406 L 15.73803806304932 1.001724243164062 L 2.412505388259888 1.011200070381165 L 9.068511962890625 7.667213439941406 M 9.068292617797852 9.081214904785156 L 2.250671286674333e-06 0.01291506830602884 L 18.15500259399414 5.068206974101486e-06 L 9.068292617797852 9.081214904785156 Z",
    stroke: "none",
    fill: "#3566a2"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_7152",
    "data-name": "Path 7152",
    d: "M9.068,0l9.087,9.081L0,9.068Z",
    transform: "translate(78.61 3031.434) rotate(135)",
    fill: "#2c347f"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Path_7153",
    "data-name": "Path 7153",
    transform: "translate(72.189 3050.678) rotate(-135)",
    fill: "#3f7fce"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 9.068374633789062 8.374223709106445 L 1.206242084503174 0.5120915770530701 L 16.94651222229004 0.5008640289306641 L 9.068374633789062 8.374223709106445 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 9.06849193572998 7.667221069335938 L 15.73803043365479 1.001726269721985 L 2.412501811981201 1.011231422424316 L 9.06849193572998 7.667221069335938 M 9.068272590637207 9.081221580505371 L 2.250671286674333e-06 0.0129517437890172 L 18.15500259399414 1.743926986819133e-06 L 9.068272590637207 9.081221580505371 Z",
    stroke: "none",
    fill: "#3f7fce"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_7156",
    "data-name": "Path 7156",
    transform: "translate(72.189 3063.471) rotate(-135)",
    fill: "#95c0ed"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 9.068374633789062 8.374223709106445 L 1.206242084503174 0.5120915770530701 L 16.94651222229004 0.5008640289306641 L 9.068374633789062 8.374223709106445 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 9.06849193572998 7.667221069335938 L 15.73803043365479 1.001726269721985 L 2.412501811981201 1.011231422424316 L 9.06849193572998 7.667221069335938 M 9.068272590637207 9.081221580505371 L 2.250671286674333e-06 0.0129517437890172 L 18.15500259399414 1.743926986819133e-06 L 9.068272590637207 9.081221580505371 Z",
    stroke: "none",
    fill: "#95c0ed"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -9, -6)",
    filter: "url(#Screenshot_2023-01-08_at_11.37.39_PM-2)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Screenshot_2023-01-08_at_11.37.39_PM-4",
    "data-name": "Screenshot 2023-01-08 at 11.37.39 PM",
    width: 50,
    height: 50,
    rx: 12,
    transform: "translate(9 6)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Poligon-2",
    "data-name": "Poligon",
    transform: "translate(-44.965 -3016.715)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_7151-2",
    "data-name": "Path 7151",
    transform: "translate(75.237 3041.736) rotate(-135)",
    fill: "#214a80"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 14.56772994995117 7.390477180480957 L 1.206240057945251 7.38095760345459 L 7.88020133972168 0.7069964408874512 L 14.56772994995117 7.390477180480957 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 7.880318164825439 1.413999557495117 L 2.412501335144043 6.881816864013672 L 13.35925102233887 6.889616012573242 L 7.880318164825439 1.413999557495117 M 7.880099296569824 -1.430511474609375e-06 L 15.77621936798096 7.891338348388672 L -9.5367431640625e-07 7.880098342895508 L 7.880099296569824 -1.430511474609375e-06 Z",
    stroke: "none",
    fill: "#214a80"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_7155-2",
    "data-name": "Path 7155",
    transform: "translate(64.12 3052.853) rotate(-135)",
    fill: "#559ae2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 14.56772994995117 7.390477180480957 L 1.206240057945251 7.38095760345459 L 7.88020133972168 0.7069964408874512 L 14.56772994995117 7.390477180480957 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 7.880318164825439 1.413999557495117 L 2.412501335144043 6.881816864013672 L 13.35925102233887 6.889616012573242 L 7.880318164825439 1.413999557495117 M 7.880099296569824 -1.430511474609375e-06 L 15.77621936798096 7.891338348388672 L -9.5367431640625e-07 7.880098342895508 L 7.880099296569824 -1.430511474609375e-06 Z",
    stroke: "none",
    fill: "#559ae2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_7154-2",
    "data-name": "Path 7154",
    transform: "translate(80.817 3036.169) rotate(135)",
    fill: "#3566a2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 7.880208492279053 7.184340953826904 L 1.206238031387329 0.5103705525398254 L 14.56774711608887 0.5008594393730164 L 7.880208492279053 7.184340953826904 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 7.880325794219971 6.477338314056396 L 13.35926818847656 1.001719951629639 L 2.412499666213989 1.009512186050415 L 7.880325794219971 6.477338314056396 M 7.880106449127197 7.89133882522583 L -3.640289378381567e-06 0.01122893579304218 L 15.77623653411865 -1.064224193214613e-06 L 7.880106449127197 7.89133882522583 Z",
    stroke: "none",
    fill: "#3566a2"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_7152-2",
    "data-name": "Path 7152",
    d: "M7.88,0l7.9,7.891L0,7.88Z",
    transform: "translate(75.25 3030.591) rotate(135)",
    fill: "#2c347f"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Path_7153-2",
    "data-name": "Path 7153",
    transform: "translate(69.67 3047.313) rotate(-135)",
    fill: "#3f7fce"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 7.88019847869873 7.184357166290283 L 1.206236481666565 0.5103949904441833 L 14.56774520874023 0.5008669495582581 L 7.88019847869873 7.184357166290283 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 7.880315780639648 6.477354526519775 L 13.35926532745361 1.001728892326355 L 2.412496566772461 1.009535074234009 L 7.880315780639648 6.477354526519775 M 7.880096435546875 7.891355037689209 L -3.640289378381567e-06 0.01125489640980959 L 15.77623653411865 4.896240170637611e-06 L 7.880096435546875 7.891355037689209 Z",
    stroke: "none",
    fill: "#3f7fce"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_7156-2",
    "data-name": "Path 7156",
    transform: "translate(69.67 3058.431) rotate(-135)",
    fill: "#95c0ed"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 7.88019847869873 7.184357166290283 L 1.206236481666565 0.5103949904441833 L 14.56774520874023 0.5008669495582581 L 7.88019847869873 7.184357166290283 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 7.880315780639648 6.477354526519775 L 13.35926532745361 1.001728892326355 L 2.412496566772461 1.009535074234009 L 7.880315780639648 6.477354526519775 M 7.880096435546875 7.891355037689209 L -3.640289378381567e-06 0.01125489640980959 L 15.77623653411865 4.896240170637611e-06 L 7.880096435546875 7.891355037689209 Z",
    stroke: "none",
    fill: "#95c0ed"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPublishedMap);
export default __webpack_public_path__ + "static/media/publishedMap.83ac035c595cc58c2875dce9ac081caf.svg";
export { ForwardRef as ReactComponent };